import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RouterModule } from '@angular/router';
import { ApiService } from '@/app/modules/dashboard/infra/api.service';
import { ConsolidatedTransfer } from '@/app/modules/dashboard/core/types';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'app-transfer-table',
  standalone: true,
  imports: [
    CommonModule,
    NzTagModule,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule,
    RouterModule,
    FormsModule,
    NzInputModule,
    NzGridModule,
    NzEmptyModule,
  ],
  templateUrl: './transfer-table.component.html',
  styleUrl: './transfer-table.component.scss',
})
export class TransferTableComponent implements OnInit {
  @Input() isMonitorMode = false;

  loading = false;
  listOfData: ConsolidatedTransfer[] = [];

  pending: ConsolidatedTransfer[] = [];
  received: ConsolidatedTransfer[] = [];

  displayPending: ConsolidatedTransfer[] = [];
  displayReceived: ConsolidatedTransfer[] = [];

  searchPending = '';
  searchReceived = '';

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.apiService.getTransfersTracking().subscribe({
      next: (data) => {
        this.listOfData = data;
        this.pending = data
          .filter((item) => item.status === 'pending')
          .sort(
            (a, b) =>
              new Date(a.sentDate).getTime() - new Date(b.sentDate).getTime(),
          );
        this.received = data
          .filter((item) => item.status === 'received')
          .sort(
            (a, b) =>
              new Date(b.receivedDate ?? b.sentDate).getTime() -
              new Date(a.receivedDate ?? a.sentDate).getTime(),
          );
        this.applyFilters();
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading transfers:', err);
        this.pending = [];
        this.received = [];
        this.applyFilters();
        this.loading = false;
      },
    });
  }

  applyFilters(): void {
    this.displayPending = this.filterList(this.pending, this.searchPending);
    this.displayReceived = this.filterList(this.received, this.searchReceived);
  }

  private filterList(
    list: ConsolidatedTransfer[],
    term: string,
  ): ConsolidatedTransfer[] {
    const q = (term || '').trim().toLowerCase();
    if (!q) return [...list];
    return list.filter(
      (item) =>
        item.chassis.toLowerCase().includes(q) ||
        item.productName.toLowerCase().includes(q) ||
        item.origin.toLowerCase().includes(q) ||
        item.destination.toLowerCase().includes(q),
    );
  }
}
